
import { FeatureModelConfigMap } from './types';

// Storage key for encrypted API keys
export const STORAGE_KEY = 'feature-model-config';

// Default configurations
export const defaultConfig: FeatureModelConfigMap = {
  sitemap: {
    enabled: true,
    model: 'gpt-3.5-turbo',
    temperature: 0.7,
    maxTokens: 1000,
    retryCount: 3,
    requestTimeout: 30000, // 30 seconds
    useBackoff: true,
    apiKey: '',
    usageLimit: 100000,
    usageCount: 0,
    lastReset: new Date().toISOString()
  },
  deepAnalysis: {
    enabled: true,
    model: 'gpt-4o',  // Keep using gpt-4o but don't rely on json_object response format
    temperature: 0.2,
    maxTokens: 2000,
    retryCount: 3,
    requestTimeout: 45000, // 45 seconds
    useBackoff: true,
    apiKey: '',
    usageLimit: 200000,
    usageCount: 0,
    lastReset: new Date().toISOString()
  },
  recommended: {
    enabled: true,
    model: 'gpt-4o',
    temperature: 0.3,
    maxTokens: 2000,
    retryCount: 2,
    requestTimeout: 45000,
    useBackoff: true,
    apiKey: '',
    usageLimit: 9999999,
    usageCount: 0,
    lastReset: new Date().toISOString()
  },
  faqSerp: {
    enabled: true,
    model: 'gpt-4.5-preview',  // Updated to gpt-4.5-preview
    temperature: 0.5,
    maxTokens: 1200,
    retryCount: 2,
    requestTimeout: 30000, // 30 seconds
    useBackoff: true,
    apiKey: '',
    usageLimit: 100000,
    usageCount: 0,
    lastReset: new Date().toISOString()
  },
  ecoAssistant: {
    enabled: true,
    model: 'gpt-4o',
    temperature: 0.4,
    maxTokens: 2000,
    retryCount: 2,
    requestTimeout: 45000, // 45 seconds
    useBackoff: true,
    apiKey: '',
    usageLimit: 150000,
    usageCount: 0,
    lastReset: new Date().toISOString()
  }
};
